import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { decimalToStep } from '@ui/util/decimal-transforms';
import { get, useFormContext, useWatch } from 'react-hook-form';

export function CustomerPortalsForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const portalsAdjustmentFieldPath = fieldPath('portalsAdjustment');

  const decimalPlaces = useWatch({
    name: 'decimalPlaces',
    control: form.control,
    defaultValue: '2',
  }) as string;

  return (
    <>
      <FormControl
        isInvalid={!!get(form.formState.errors, portalsAdjustmentFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={portalsAdjustmentFieldPath}>Adjustment:</FormLabel>

        <Input
          {...form.register(portalsAdjustmentFieldPath)}
          type="number"
          inputMode="numeric"
          id={portalsAdjustmentFieldPath}
          step={decimalToStep(decimalPlaces)}
        />

        <ErrorMessage
          name={fieldPath('portalsAdjustment')}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </>
  );
}
